import React, { useEffect } from "react";
import AdsFilterPanel from "./Adsfilterpanel";
import FilterChip from "./FilterChip";
import { formatRupees } from "../../utils/formatRupees";
import useAdsFilterPanel from "./useAdsFilterpanel";

const CampaignFilter = ({ appliedFilters, setAppliedFilters, handleApplyFilters }) => {
  const { apiData: filterApiData, loading: filterApiLoading, refetch } = useAdsFilterPanel();

  const removeFilter = (key) => {
    const updatedFilters = { ...appliedFilters };
    delete updatedFilters[key];
    handleApplyFilters(updatedFilters);
  };

  const removeMultiFilter = (key, value) => {
    const current = toArrayRemove(appliedFilters[key]);

    const updatedArray = current.filter((item) => item !== value);

    const updatedFilters = { ...appliedFilters };

    if (updatedArray.length === 0) {
      delete updatedFilters[key]; //  important
    } else {
      updatedFilters[key] = updatedArray;
    }

    handleApplyFilters(updatedFilters);
  };

  useEffect(() => {
    const container = document.getElementById("chipContainer");
    const leftBtn = document.getElementById("scrollLeftBtn");
    const rightBtn = document.getElementById("scrollRightBtn");

    if (!container || !leftBtn || !rightBtn) return;

    const updateButtons = () => {
      const scrollLeft = Math.ceil(container.scrollLeft);
      const maxScroll = container.scrollWidth - container.clientWidth;

      leftBtn.style.display = scrollLeft > 5 ? "flex" : "none";
      rightBtn.style.display = maxScroll > scrollLeft + 5 ? "flex" : "none";
    };

    updateButtons();
    container.addEventListener("scroll", updateButtons);
    window.addEventListener("resize", updateButtons);

    // Initial check with a small delay for content rendering
    const timer = setTimeout(updateButtons, 200);

    leftBtn.onclick = () => container.scrollBy({ left: -200, behavior: "smooth" });
    rightBtn.onclick = () => container.scrollBy({ left: 200, behavior: "smooth" });

    return () => {
      container.removeEventListener("scroll", updateButtons);
      window.removeEventListener("resize", updateButtons);
      clearTimeout(timer);
    };
  }, [appliedFilters]);

  const toArrayRemove = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

  const toArray = (value) => {
    if (value === null || value === undefined || value === "") return [];

    if (Array.isArray(value)) return value;

    if (value === "undefined" || value === "null") return [];

    // comma separated string handle
    if (typeof value === "string" && value.includes(",")) {
      return value.split(",").filter(Boolean);
    }

    return [value];
  };

  return (
    <div className="container-fluid common-component-header-campaign mt-2 breadcrumb-common-header">
      <div className="row align-items-center">
        {/* Chips Column */}
        <div className="col">
          <div className="filter-chip-wrapper">
            <button className="scroll-btn left" id="scrollLeftBtn" type="button">‹</button>

            <div className="chip-scroll" id="chipContainer">
              {toArray(appliedFilters?.status).map((c) => (
                <FilterChip key={c} label={c} onRemove={() => removeMultiFilter("status", c)} />
              ))}

              {toArray(appliedFilters?.ads_type).map((type) => (
                <FilterChip key={type} label={type} onRemove={() => removeMultiFilter("ads_type", type)} />
              ))}

              {toArray(appliedFilters?.matchTypes).map((type) => (
                <FilterChip key={type} label={type} onRemove={() => removeMultiFilter("matchTypes", type)} />
              ))}

              {toArray(appliedFilters?.brand).map((b) => (
                <FilterChip key={b} label={b} onRemove={() => removeMultiFilter("brand", b)} />
              ))}

              {appliedFilters?.searchTerm && (
                <FilterChip label={appliedFilters?.searchTerm} onRemove={() => removeFilter("searchTerm")} />
              )}

              {appliedFilters?.clicks?.length === 2 && (
                <FilterChip label={`Clicks: ${appliedFilters.clicks[0]} - ${appliedFilters.clicks[1]}`} onRemove={() => removeFilter("clicks")} />
              )}

              {appliedFilters?.spend?.length === 2 && (
                <FilterChip label={`Spend: ${formatRupees(appliedFilters.spend[0])} - ${formatRupees(appliedFilters.spend[1])}`} onRemove={() => removeFilter("spend")} />
              )}

              {appliedFilters?.sales?.length === 2 && (
                <FilterChip label={`Sales: ${formatRupees(appliedFilters.sales[0])} - ${formatRupees(appliedFilters.sales[1])}`} onRemove={() => removeFilter("sales")} />
              )}
            </div>

            <button className="scroll-btn right" id="scrollRightBtn" type="button">›</button>
          </div>
        </div>

        {/* Filter Trigger Button Column */}
        <div className="col-auto">
          <button
            className={`campaign-filter btn ${filterApiLoading ? "disabled-campaign-filter-btn" : ""}`}
            type="button"
            data-bs-toggle={!filterApiLoading ? "offcanvas" : undefined}
            data-bs-target={!filterApiLoading ? "#offcanvasRight" : undefined}
          >
            <i className="bi bi-filter"></i>
          </button>
        </div>
      </div>

      {/* Offcanvas remains at the bottom */}
      <div className="offcanvas offcanvas-end offcanvas-campaign" tabIndex="-1" id="offcanvasRight">
        <div className="offcanvas-header border-bottom">
          <span className="fw-bold">FILTERS</span>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>
        <div className="offcanvas-body p-0">
          <AdsFilterPanel apiData={filterApiData} onApply={handleApplyFilters} appliedFilters={appliedFilters} />
        </div>
      </div>
    </div>
  );
};

export default CampaignFilter;

